import React from 'react';
import styles from './index.module.scss';
import { getImageFromS3 } from '../../../imageService';

const HomeScreen = ({ backgroundImage }) => {
  return (
    <div className={styles.container}>
      <div className={styles.content} style={{ backgroundImage }}>
        <p className={styles.title}>
          Зміни у формі<br></br> компактних пачок
        </p>
        <div className={styles.packsListContainer}>
          <p className={styles.title}>Ширшими стали</p>
          <p className={styles.description}>
            продукти компактного формату від брендів{' '}
            <b>Marlboro, Parliament Soho, L&M, Chesterfield</b> та{' '}
            <b>Philip Morris</b> вироблені на власній фабриці в Україні
          </p>
          <img
            className={styles.bg}
            src={getImageFromS3('images/sms-cmp-frmt/violet-bg.png')}
            alt="violet-bg"
          />
          <img
            className={styles.packs}
            src={getImageFromS3('images/sms-cmp-frmt/packs.png')}
            alt="packs"
          />
        </div>
        <div className={styles.formatTitleWrapper}>
          <div className={styles.formatTitleContainer}>
            <p className={styles.title}>Якщо бажаєш залишити відгук</p>
            <p className={styles.description}>
              про новий формат продукту - можеш відсканувати{' '}
              <b>qr-код всередині пачки</b> та написати нам про свій досвід!
            </p>
          </div>
        </div>
        <img
          className={styles.qrOpportunities}
          src={getImageFromS3('images/sms-cmp-frmt/qr.png')}
          alt="qr"
        />
        <div className={styles.differencesContainer}>
          <p className={styles.title}>Давай перевіримо,</p>
          <p className={styles.description}>
            можливо саме твоя пачка вже <br></br>має нову форму
          </p>
          <div className={styles.comparisonContainer}>
            <div className={styles.oldPackContainer}>
              <p className={styles.packContainerTitle}>Було</p>
              <img
                src={getImageFromS3('images/sms-cmp-frmt/oldPack.png')}
                alt="oldPack"
              />
            </div>
            <div className={styles.newPackContainer}>
              <p className={styles.packContainerTitle}>Стало</p>
              <img
                src={getImageFromS3('images/sms-cmp-frmt/newPack.png')}
                alt="newPack"
              />
              <div className={styles.list}>
                <div className={styles.listItem}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="6"
                    height="7"
                    viewBox="0 0 6 7"
                    fill="none"
                  >
                    <path
                      d="M5.5 2.63398C6.16667 3.01888 6.16667 3.98113 5.5 4.36603L1.75 6.53109C1.08333 6.91599 0.25 6.43486 0.25 5.66506L0.25 1.33493C0.25 0.565134 1.08333 0.0840107 1.75 0.468911L5.5 2.63398Z"
                      fill="#FFB578"
                    />
                  </svg>
                  <p>
                    <b>ширша</b> пачка
                  </p>
                </div>
                <div className={styles.listItem}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="6"
                    height="7"
                    viewBox="0 0 6 7"
                    fill="none"
                  >
                    <path
                      d="M5.5 2.63398C6.16667 3.01888 6.16667 3.98113 5.5 4.36603L1.75 6.53109C1.08333 6.91599 0.25 6.43486 0.25 5.66506L0.25 1.33493C0.25 0.565134 1.08333 0.0840107 1.75 0.468911L5.5 2.63398Z"
                      fill="#FFB578"
                    />
                  </svg>
                  <p style={{ border: 'none' }}>
                    <b>продуктові характеристики залишились незмінними</b>
                  </p>
                </div>
                <div className={styles.listItem}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="6"
                    height="7"
                    viewBox="0 0 6 7"
                    fill="none"
                  >
                    <path
                      d="M5.5 2.63398C6.16667 3.01888 6.16667 3.98113 5.5 4.36603L1.75 6.53109C1.08333 6.91599 0.25 6.43486 0.25 5.66506L0.25 1.33493C0.25 0.565134 1.08333 0.0840107 1.75 0.468911L5.5 2.63398Z"
                      fill="#FFB578"
                    />
                  </svg>
                  <p style={{ border: 'none' }}>
                    <b>
                      споживачі кажуть, що сигарети тепер діставати стало
                      зручніше
                    </b>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.footer}>
        Куріння викликає серйозні захворювання та залежність Дана інформація про
        продукт надається відповідно до статті 15 Закону України «Про захист
        прав споживачів»
      </div>
      <div className={styles.unsubscribe}>
        Ти отримав(-ла) лист, оскільки залишав(-ла) запит на отримання
        інформації про продукцію компаній Philip Morris в Україні. <br />
        <a href="/unsubscribe?returnLink=25-sms-cmp-frmt">
          Відписатися від SMS тут.
        </a>
      </div>
    </div>
  );
};

export default HomeScreen;
